<template>
    <b-button
        :class="[childClass, 'btn btn-pdv btn-pdv-red']"
        :disabled="busy"
        @click="$emit('onClick')">
        {{ getI18n('COMMON.cancel') }}
    </b-button>
</template>

<script>
export default {
    props: {
        childClass: {
            type: String,
            required: false,
            default: ''
        },
        busy: {
            type: Boolean,
            required: false,
        },
    },
}
</script>
